import { defineMessages, type MessageDescriptor } from 'react-intl';
import './theme.css';
import type { AgentLogo } from '@/app/lib/stage/StageHeader.tsx';

const siteMessages = defineMessages({
  askPlaceholder: {
    id: 'composer.businessPrompt',
    defaultMessage: 'What would you like to improve in your business?',
    description: 'Invitation shown inside the empty composer.',
  },
});

export interface SiteConfig {
  brandName: string;
  /** Optional logo in a scrolling circle. Clicking sends Start over within this conversation. */
  logo?: AgentLogo;
  /** The assistant's appearance. 'auto' follows the visitor's OS. */
  appearance: 'light' | 'dark' | 'auto';
  /** Omnibox placeholder override. */
  placeholder?: MessageDescriptor;
}

export const SITE_CONFIG: SiteConfig = {
  brandName: 'BEQSON',
  logo: {
    src: 'https://storage.agentplace.io/-zYcE8KCKd-K3317yO20jtNAbo_s1IG9EwHJbvl1RGE/k4h7xqtesbe9/media/1792611959438-26f90780-f466-4da7-ae44-a21c451d3e6c-beqson-mark-v3.png',
    alt: 'BEQSON Digital Studio',
  },
  appearance: 'dark',
  placeholder: siteMessages.askPlaceholder,
};
